import {createTheme, CSSVariablesResolver, MantineColorsTuple, MantineTheme} from "@mantine/core";

export const brand: MantineColorsTuple = [
    '#eaf3f8', // 0
    '#d6e8f2', // 1
    '#b7d7e8', // 2
    '#94c2db', // 3
    '#72adce', // 4
    '#4f98c1', // 5
    '#1E6A98', // 6
    '#17577c', // 7
    '#11425e', // 8
    '#0a2c3f', // 9
]


export const resolver: CSSVariablesResolver = (theme) => ({
    variables: {
        '--app-link-color': theme.other.linkColor,
        '--app-link-hover-color': theme.other.linkHoverColor,
    },

    light: {},
    dark: {},
})

export const theme = createTheme({
    defaultRadius: 0,
    colors: {brand},
    primaryColor: 'brand',
    other: {
        linkColor: '#278cc9',
        linkHoverColor: '#1f70a1'
    },
    breakpoints: {
        xs: '30em', // 480px
        sm: '36em', // 576px
        md: '48em', // 768px
        lg: '62em', // 992px
        xl: '75em', // 1200px
    },
    primaryShade: {light: 6, dark: 6},
    shadows: {md: '0 0 10px 0 rgba(0, 0, 0, 0.06)'},
    fontFamily: '"Poppins", sans-serif',
    headings: {
        fontFamily: '"Righteous", sans-serif',
        fontWeight: '400',
    },
    radius: {md: '12px', lg: '16px'},

    components: {
        Container: {
            defaultProps: {
                size: { base: '100%', sm: 'sm', md: 'md', lg: 'lg', xl: 'xl' },
            },

        },
        Anchor: {
            defaultProps: {underline: 'never'},
            // styles: (theme: MantineTheme) => ({
            //     root: {
            //         color: 'var(--app-link-color)',
            //         '&:hover': {color: 'var(--app-link-hover-color)', textDecoration: 'underline',},
            //         '&:visited': {color: 'var(--app-link-color)',},
            //     },
            // }),
        },
        Button: {
            styles: {
                root: {
                    transition: 'background-color 0.25s ease, transform 0.15s ease',
                    '&:hover': {transform: 'translateY(-1px)'},
                },
            },
        },
    },
})



